import { cx } from '@linaria/core';

import { StyledFlex } from './styles';
import type { FlexProps } from './types';

export const Flex = ({
	children,
	className,
	direction,
	gap,
	align,
	justify,
	as,
	...props
}: FlexProps) => (
	<StyledFlex
		{...props}
		className={cx(
			className,
			direction && 'direction',
			gap && 'gap',
			align && 'align',
			justify && 'justify'
		)}
		direction={direction}
		gap={gap}
		align={align}
		justify={justify}
		as={as}
	>
		{children}
	</StyledFlex>
);
